import React from "react";

export default function Policies() {
  return (
    <div>
      <div className="container p-3 my-3">
        <h1 className="text-center">
          Generic Return and Refund Policy template
        </h1>
        <hr />
        <p>
          <h2> Return and Refund Policy</h2>
          Thanks for shopping at MAOS Store. If you are not entirely satisfied
          with your purchase, we're here to help.
          <h3 className="strong">Returns</h3>
          You have 14 (according to the local law) calendar days to return an
          item from the date you received it. To be eligible for a return, your
          item must be unused and in the same condition that you received it.
          Your item must be in the original packaging. Your item needs to have
          the receipt or proof of purchase. For additional information in this
          section, create your own Return and Refund Policy.
          <h3 className="strong">Refund</h3>
          Once we receive your item, we will inspect it and notify you that we
          have received your returned item. We will immediately notify you on
          the status of your refund after inspecting the item. If your return is
          approved, we will initiate a refund to your credit card (or original
          method of payment). You will receive the credit within a certain
          amount of days, depending on your card issuer's policies.
        </p>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Policies.js